import React, { Component } from "react";

import "../assets/css/footer.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";

export default class Footer extends Component {
  state = {
    email: "",
  };

  handleChange(event) {
    this.setState({ email: event.target.value });
  }

  render() {
    const position = !!this.props.position ? this.props.position : "relative";

    return (
      <div
        className="rodape_desk"
        style={{
          position,
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: "#1A1B1C",
          width: "100%",
          zIndex: 100,
        }}
      >
        <div
          className="ui grid centered middle aligned gridRodape"
          style={customStyle.rodape}
        >
          <div className="eight wide column">
            <div className="ui inverted link horizontal list">
              <a className="item"></a>
            </div>
            <p style={{ color: "white", fontSize: "smaller" }}>
              © Copyright 2008 - {new Date().getFullYear()} Grupo Voitto - TODOS
              OS DIREITOS RESERVADOS.
            </p>
            <p></p>
          </div>
          <div className="seven wide column">
            <div
              className="ui basic center aligned segment"
              style={customStyle.divFlex}
            >
              Powered by{" "}
              <img
                style={customStyle.imgDefault}
                alt="Uma empresa selecionada no Endevor Promessas"
                src="https://files.voitto.com.br/ftp-files/assets/images/voitto-white-full.png?size=200"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const customStyle = {
  imgDefault: {
    height: "35px",
    marginLeft: "1%",
  },
  divFlex: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "Center",
    color: "white",
    fontSize: "smaller",
  },
  rodape: {
    marginBottom: "0px",
  },
};
